import React, { useContext, useEffect } from "react";
import { ParagraphText } from "./../../../Libraries";
import { DiscountAndTax } from "../index.js";
import styles from "./styles.module.css";
import { LanguageContext } from "../../../context/LanguageContext.js";
import { formatNum } from "../../../oscar-pos-core/constants/index.js";
import { Box } from "@mui/material";
import { CloseIcon } from "../../../assets/icons/icon.jsx";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const NetCalculationCard = ({
  subTotalAmt,
  totalDiscount,
  setTotalDiscount,
  handleTotalDiscount,
  totalTax,
  setTotalTax,
  handleTotalTax,
  totalAmount = 0,
  children,
  handleGetError = () => {},
  handleDiscountLogEvent = () => {},
  handleTaxLogEvent = () => {},
  isEditMode = false,
}) => {
  const [I18n] = useContext(LanguageContext);
  const disabledForTax = subTotalAmt - (totalDiscount?.value || 0) == 0;

  const removeDiscount = () => {
    setTotalDiscount({ value: null, edit: false });
    handleTotalDiscount({ discount: null, discount_method: "rs" });
  };
  const updateDiscount = (e) => {
    handleTotalDiscount(e);
    setTotalDiscount({
      edit: !!e.value,
      value: e.value,
      type: e.valueMethod,
    });
  };

  const updateTax = (e) => {
    handleTotalTax(e);
    setTotalTax({
      edit: !!e.value,
      value: e.value,
      type: e.valueMethod,
    });
  };
  const removeTax = () => {
    if (totalTax.value) {
      setTotalTax({ value: null, edit: false });
      handleTotalTax({ tax: null, tax_type: "%" });
    }
  };
  useEffect(() => {
    if (disabledForTax) removeTax();
  }, [disabledForTax]);

  return (
    <Box
      className={`subtotal_card ${styles.subtotalCard} ${
        children ? `selectAmountBox ${styles.selectAmountBox}` : ""
      }`}
    >
      <Box className={`subtotalCardInnerRow ${styles.subtotalCardInnerRow}`}>
        <Box className={`subtotalCardInnerRowLeft ${styles.subtotalCardInnerRowLeft}`}>
          <ParagraphText className="fontSize14 newFontColor">
            {I18n.subtotal}
          </ParagraphText>
        </Box>
        <Box className={`subtotalCardInnerRowRight ${styles.subtotalCardInnerRowRight}`}>
          <ParagraphText className="fontSize14 newFontColor">
            Rs. {formatNum(subTotalAmt) || 0}
          </ParagraphText>
        </Box>
      </Box>

      <Box className={`subtotalCardInnerRow subtotalCardInnerInputRow ${styles.subtotalCardInnerRow} ${styles.subtotalCardInnerInputRow}`}>
        <Box
          className={`subtotalCardInnerRowLeft cursorPointer ${styles.subtotalCardInnerRowLeft}`}
        >
          <ParagraphText
            tabIndex={0}
            id="add_tax_id"
            className={"discountAndTaxLabel fontSize14 fontWeight500 newFontColor"}
            style={{              
              textDecoration: totalTax?.value ? "none" : "underline",
            }}
            onClick={() => {
              triggerLogEvent(analytics, "pos_add_tax_clicked");
              setTotalTax((td) => ({
                edit: true,
                value: td.value,
                type: "%",
              }));
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey)
                setTotalTax((td) => ({
                  edit: true,
                  value: td.value,
                  type: "%",
                }));
            }}
          >
            {totalTax?.value ? I18n.tax_added : I18n.add_tax}
          </ParagraphText>
          {totalTax?.value ? (
            <ParagraphText
              id="remove_tax_id"
              className="pointer fontSize13"
              style={{
                color: !totalTax?.value
                  ? "var(--grayNewShade)"
                  : "var(--foundationBlueDark)",
                textDecoration: !totalTax?.value ? "underline" : "underline",
              }}
              onClick={() => {
                triggerLogEvent(analytics, "pos_remove_tax_clicked");
                removeTax();
              }}
            >
              <span className={styles.closeIcon}>
                <CloseIcon />
              </span>
            </ParagraphText>
          ) : null}
        </Box>

        <Box
          className={`subtotalCardInnerRowRight ${styles.subtotalCardInnerRowRight}`}
        >
          <DiscountAndTax
            item={{}}
            onUpdate={updateTax}
            value={totalTax?.value}
            valueMethod={totalTax?.type}
            totalAmount={totalAmount}
            from={"tax"}
            className={styles.calulateDiscountAndTax}
            open={totalTax?.edit}
            handleGetError={handleGetError}
            disabled={disabledForTax}
            handleLogEvent={handleTaxLogEvent}
            isEditMode={isEditMode}
          />
        </Box>
      </Box>

      {/* Discount Section */}
      <Box
        className={`subtotalCardInnerRow subtotalCardInnerInputRow ${styles.subtotalCardInnerRow} ${styles.subtotalCardInnerInputRow}`}
      >
        <Box
          className={`subtotalCardInnerRowLeft cursorPointer ${styles.subtotalCardInnerRowLeft}`}
        >
          <ParagraphText
            tabIndex={0}
            id="add_discount_id"
            className={"discountAndTaxLabel fontSize14 fontWeight500 newFontColor"}
            style={{
              
              textDecoration: totalDiscount?.value ? "none" : "underline",
            }}
            onClick={() => {
              triggerLogEvent(analytics, "pos_add_discount_clicked");
              setTotalDiscount((td) => ({
                edit: true,
                value: td.value,
                type: "rs",
              }));
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey)
                setTotalDiscount((td) => ({
                  edit: true,
                  value: td.value,
                  type: "rs",
                }));
            }}
          >
            {totalDiscount?.value ? I18n.disount_added : I18n.add_dicount}
          </ParagraphText>
          {totalDiscount?.value ? (
            <ParagraphText
              className="pointer fontSize13"
              style={{
                color: !totalDiscount?.value
                  ? "var(--grayNewShade)"
                  : "var(--foundationBlueDark)",
                textDecoration: !totalDiscount?.value ? "none" : "underline",
              }}
              id="remove_discount_id"
              onClick={() => {
                triggerLogEvent(analytics, "pos_remove_discount_clicked");
                removeDiscount();
              }}
            >
              <span className={styles.closeIcon}>
                <CloseIcon />
              </span>
            </ParagraphText>
          ) : null}
        </Box>

        <Box className={styles.subtotalCardInnerRowRight}>
          <DiscountAndTax
            item={{}}
            onUpdate={updateDiscount}
            value={totalDiscount?.value}
            valueMethod={totalDiscount?.type}
            totalAmount={totalAmount}
            className={`calulateDiscountAndTax ${styles.calulateDiscountAndTax}`}
            open={totalDiscount?.edit}
            handleGetError={handleGetError}
            handleLogEvent={handleDiscountLogEvent}
            isEditMode={isEditMode}
          />
        </Box>
      </Box>      
      {children}
    </Box>
  );
};

export default NetCalculationCard;
